import { Icons } from '@shared/components/content/icons';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type Props = {
  to: string;
  className?: string;
  children: ReactNode;
};

/** Small teal drill-through link with a trailing chevron, for panel headers. */
export function DrillthroughLink({ to, className, children }: Props) {
  return (
    <Link
      to={to}
      className={cn(
        'group inline-flex items-center gap-0.5 text-sm font-medium text-teal-600 hover:text-teal-700',
        className
      )}
    >
      {children}
      <Icons.chevronRight className="size-3.5 transition-transform group-hover:translate-x-0.5" />
    </Link>
  );
}
